import { supabase } from '../lib/supabase';

export const authService = {
  // Sign up new user
  async signUp(email, password, userData) {
    // Clear any existing session before signup to prevent token conflicts
    try {
      await supabase?.auth?.signOut({ scope: 'local' });
    } catch (signOutError) {
      console.log('No existing session to clear');
    }

    const { data, error } = await supabase?.auth?.signUp({
      email,
      password,
      options: {
        data: {
          full_name: userData?.fullName || '',
          phone: userData?.phone || '',
          id_number: userData?.idNumber || '',
          id_type: userData?.idType || 'CC',
          user_type: userData?.userType || 'user',
          membership_tier: userData?.membershipTier || 'Explorador',
          referral_code: userData?.referralCode || '',
          avatar_url: userData?.avatarUrl || ''
        }
      }
    });
    
    if (error) throw error;
    return data;
  },

  // Sign in with email and password
  async signIn(email, password) {
    // Clear any existing session before signin to prevent token conflicts
    try {
      await supabase?.auth?.signOut({ scope: 'local' });
    } catch (signOutError) {
      console.log('No existing session to clear');
    }

    const { data, error } = await supabase?.auth?.signInWithPassword({
      email,
      password
    });
    
    if (error) throw error;
    return data;
  },

  // Sign out
  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  // Get current user
  async getCurrentUser() {
    const { data: { user }, error } = await supabase?.auth?.getUser();
    if (error) throw error;
    return user;
  },

  // Update user password
  async updatePassword(newPassword) {
    const { data, error } = await supabase?.auth?.updateUser({
      password: newPassword
    });
    
    if (error) throw error;
    return data;
  },

  // Send password reset email
  async resetPassword(email) {
    const { data, error } = await supabase?.auth?.resetPasswordForEmail(email, {
      redirectTo: 'https://www.bizznet.com.co/password-recovery-verification'
    });
    if (error) throw error;
    return data;
  }
};